// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"c3afad37","477":"e85d61df","615":"f19891f8","658":"d5f41582","684":"b2e1411d","752":"bb5ec575"}[chunkId] + ".chunk.css";
};